import React, { createContext, useContext, useState } from 'react';
import { Initiative } from '../services/api';

interface EditInitiativeContextType {
  editData: Partial<Initiative> | null;
  setEditData: (data: Partial<Initiative> | null) => void;
  switchToSubmitTab: () => void;
  switchToSubmissionsTab: () => void;
  switchToHomeTab: () => void;
  setOnSwitchTab: (callback: (tabId: string) => void) => void;
  successMessage: string | null;
  setSuccessMessage: (message: string | null) => void;
}

const EditInitiativeContext = createContext<EditInitiativeContextType | undefined>(undefined);

export const EditInitiativeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [editData, setEditData] = useState<Partial<Initiative> | null>(null);
  const [onSwitchTab, setOnSwitchTab] = useState<((tabId: string) => void) | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const switchToSubmitTab = () => {
    if (onSwitchTab) {
      onSwitchTab('submit');
    }
  };

  const switchToSubmissionsTab = () => {
    if (onSwitchTab) {
      onSwitchTab('submissions');
    }
  };

  const switchToHomeTab = () => {
    if (onSwitchTab) {
      onSwitchTab('home');
    }
  };

  return (
    <EditInitiativeContext.Provider value={{
      editData,
      setEditData,
      switchToSubmitTab,
      switchToSubmissionsTab,
      switchToHomeTab,
      setOnSwitchTab: (callback) => setOnSwitchTab(() => callback),
      successMessage,
      setSuccessMessage,
    }}>
      {children}
    </EditInitiativeContext.Provider>
  );
};

export const useEditInitiative = () => {
  const context = useContext(EditInitiativeContext);
  if (!context) {
    throw new Error('useEditInitiative must be used within EditInitiativeProvider');
  }
  return context;
};
